var render = function render(){var _vm=this,_c=_vm._self._c;return _c('smart-link',{staticClass:"text-link",attrs:{"to":_vm.to}},[_c('span',{staticClass:"arrow"},[_c('div',{staticClass:"icon-arrow-right-long"})]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }